/**
 * Fetches /api/benchmarks/{weddingId} whenever the current wedding changes.
 * Extracted from DashboardPage as part of Phase B.6 — keeps the page concise
 * and lets `SpendingBenchmarksCard` + `EventBenchmarksCard` both share data.
 */
import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useBenchmarks(weddingId) {
  const [data, setData] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    if (!weddingId) return;
    let cancelled = false;
    axios
      .get(`${BACKEND_URL}/api/benchmarks/${weddingId}`, { withCredentials: true })
      .then((res) => {
        if (cancelled) return;
        setData(res.data);
        const eventKeys = Object.keys(res.data?.event_benchmarks || {});
        if (eventKeys.length > 0) setSelectedEvent(eventKeys[0]);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [weddingId]);

  return { benchmarkData: data, selectedEvent, setSelectedEvent };
}
